<template>
	<section
		class="container container--a margin-module"
		:class="[{ 'has-title': data.module_title }, pageTheme ? 'theme--' + pageTheme : '']"
		v-observe-visibility="visibilityChanged"
	>
		<div :class="{ 'is-playing': videoIsPlaying }" class="video-player">
			<WpImage
				v-if="data.video_placeholder"
				:image="data.video_placeholder"
				size="medium_large"
				background
				lazy
				cover
			/>
			<button @click="startVideo" class="play-video">
				<span class="txt">Play</span>
				<span class="ico" v-html="playIcon"></span>
			</button>
			<div v-if="data.video" class="responsive-embed" ref="videoPlayer" v-html="data.video"></div>
		</div>
		<div class="module-title" v-if="data.module_title">
			<div class="inner font-size--26 font--600" v-html="data.module_title"></div>
		</div>
	</section>
</template>

<script>
import Player from '@vimeo/player'
import { play } from '@/icons.js'
import WpImage from '@/components/elements/WpImage'
import { mapGetters } from 'vuex'

import shortid from 'shortid'

export default {
	props: ['data'],
	name: 'video-module',
	data() {
		return {
			showData: false,
			iframe: null,
			videoIsPlaying: false,
			apiInit: false,
			YTPlayer: null,
			VimeoPlayer: null,
			playerType: 'unknown',
			playIcon: play(),
		}
	},
	components: {
		WpImage,
	},
	watch: {},
	mounted() {
		const VM = this
		const element = VM.$refs.videoPlayer
		if (process.server) return // we dont want to init that on the serfver
		if (element) {
			this.iframe = element.getElementsByTagName('iframe')[0]
			if (this.iframe && this.iframe.src) {
				if (this.iframe.src.indexOf('youtube') !== -1) this.playerType = 'youtube'
				if (this.iframe.src.indexOf('vimeo') !== -1) this.playerType = 'vimeo'
				//Init YT stuff
				if (this.playerType === 'youtube') {
					if (typeof YT == 'undefined' || typeof YT.Player == 'undefined') {
						let tag = document.createElement('script')
						tag.src = 'https://www.youtube.com/iframe_api'
						let firstScriptTag = document.getElementsByTagName('script')[0]
						if (firstScriptTag && firstScriptTag.parentNode) {
							firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
						}
					}

					this.iframe.src = this.iframe.src + '&enablejsapi=1'
				}
			}
		}
	},
	computed: {
		uniqVideoClass() {
			return 'video-' + shortid.generate()
		},
		...mapGetters(['pageTheme']),
	},
	destroyed() {},
	methods: {
		startVideo() {
			if (this.playerType === 'youtube' && !this.YTPlayer) {
				this.initYtVideoPlayer()
			} else if (this.playerType === 'vimeo' && !this.VimeoPlayer) {
				this.initVimeoPlayer()
			}

			if (this.apiInit) {
				this.playPauseVideo()
			}
		},

		displayPlayButton() {
			return play()
		},
		playPauseVideo() {
			if (this.videoIsPlaying) {
				this.videoIsPlaying = false
				this.stopVideo()
			} else {
				this.videoIsPlaying = true
				this.playVideo()
			}
		},
		stopVideo() {
			if (this.apiInit && this.YTPlayer) {
				this.YTPlayer.stopVideo()
			}
			if (this.apiInit && this.VimeoPlayer) {
				this.VimeoPlayer.pause()
			}
		},
		pauseVideo() {
			if (this.apiInit && this.YTPlayer) {
				this.YTPlayer.pauseVideo()
			}
			if (this.apiInit && this.VimeoPlayer) {
				this.VimeoPlayer.pause()
			}
		},
		playVideo() {
			if (this.apiInit && this.YTPlayer) {
				this.YTPlayer.playVideo()
			}
			if (this.apiInit && this.VimeoPlayer) {
				this.VimeoPlayer.play()
			}
		},
		//https://developers.google.com/youtube/iframe_api_reference
		onYtPlayerStateChange(event) {
			if (event.data === 0) {
				//video ended, trigger stop action
				this.playPauseVideo()
			}
			if (event.data === 1) {
				//video is playing, (Maybe user click on iframe itself, so handle it)
				this.videoIsPlaying = true
			}
			if (event.data === 3 && !this.videoIsPlaying) {
				this.videoIsPlaying = true
			}

			if (event.data === 2) {
				//video paused
				this.videoIsPlaying = false
			}
		},
		onYtPlayerError() {
			this.videoIsPlaying = false
			//console.log("YouTube Error");
		},
		onYtPlayerReady() {
			this.apiInit = true
			this.playPauseVideo()
		},
		initVimeoPlayer() {
			const VM = this
			const element = this.$refs.videoPlayer
			if (!element) return false
			const iframe = VM.iframe

			const opt = {}

			this.VimeoPlayer = new Player(iframe, opt)
			this.VimeoPlayer.on('pause', function () {
				VM.videoIsPlaying = false
			})
			this.VimeoPlayer.on('ended', function () {
				VM.videoIsPlaying = false
			})
			this.apiInit = true
		},
		initYtVideoPlayer() {
			const VM = this
			const element = this.$refs.videoPlayer
			if (!element) return false
			const iframe = VM.iframe
			if (typeof YT === 'undefined') return false
			this.YTPlayer = new YT.Player(iframe, {
				host: 'https://www.youtube.com',
				playerVars: {
					autoplay: 0, // no auto play in that case since we're calling play after init player
					controls: 0,
					rel: 0,
					fs: 0,
				},
				events: {
					onStateChange: VM.onYtPlayerStateChange,
					onError: VM.onYtPlayerError,
					onReady: VM.onYtPlayerReady,
				},
			})
		},
		visibilityChanged(isVisible) {
			if (!isVisible && this.videoIsPlaying) {
				this.playPauseVideo()
			}
		},
		showHidePopup() {
			this.popupOpen = !this.popupOpen
			//this.playPauseVideo();
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.module-video_block {
	&.has-title {
		.responsive-embed,
		iframe,
		.wp-image-vue,
		.wp-image-vue .image,
		.video-player {
			border-bottom-left-radius: 0 !important;
			border-bottom-right-radius: 0 !important;
		}
	}
	&.theme {
		&--red {
			.module-title,
			.play-video {
				background-color: var(--red);
			}
		}
		&--blue {
			.module-title,
			.play-video {
				background-color: var(--blue);
			}
		}
		&--green {
			.module-title,
			.play-video {
				background-color: var(--green);
			}
		}
		&--purple {
			.module-title,
			.play-video {
				background-color: var(--purple);
			}
		}
	}
	.module-title {
		border-bottom-left-radius: $radius;
		border-bottom-right-radius: $radius;
		background: var(--dark);
		color: #fff;
		margin: 0;
		padding: 25px;
		.inner {
			margin: 0 auto;
			max-width: 800px;
		}
		@include mquery($phone) {
			padding: 15px;
		}
	}
	.video-player {
		position: relative;
		overflow: hidden;
		&.is-playing {
			.wp-image-vue,
			.play-video {
				opacity: 0;
				visibility: hidden;
				pointer-events: none;
			}
		}
	}
	.responsive-embed {
		z-index: 8;
		iframe {
			border-radius: $radius;
			background-color: #010001;
		}
	}
	.wp-image-vue,
	.play-video {
		transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
		will-change: opacity, visibility;
	}

	.play-video {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
		cursor: pointer;
		border-radius: 50px;
		height: 50px;
		color: #fff;
		background-color: var(--dark);
		display: flex;
		padding: 10px 25px;
		align-items: center;
		border: none;
		box-shadow: none;
		span,
		svg {
			line-height: 1;
		}
		span {
			display: inline-block;
		}
		svg {
			width: 25px;
			height: 25px;
		}
		.ico {
			margin-left: 15px;
		}
		@include mquery($tablet) {
			min-height: 45px;
			padding: 8px 20px;
		}
		@include mquery($phone) {
			min-height: 40px;
			padding: 8px 17px;
			svg {
				width: 20px;
				height: 20px;
			}
		}
	}

	.wp-image-vue {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 9;
		.image {
			background-color: var(--lightBlue);
		}
	}
}
</style>
